import { render, staticRenderFns } from "./companyinfo.vue?vue&type=template&id=1205ba54&scoped=true&"
import script from "./companyinfo.vue?vue&type=script&lang=js&"
export * from "./companyinfo.vue?vue&type=script&lang=js&"
import style0 from "./companyinfo.vue?vue&type=style&index=0&id=1205ba54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1205ba54",
  null
  
)

export default component.exports